import React from 'react';
import { Shield, TrendingUp, Target, RefreshCw } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: Shield,
      title: 'الثقة والالتزام',
      description: 'المحافظة المستمرة على ثقة ورضى الزبائن والالتزام بوضع ومراجعة أهداف الجودة باستمرار.',
      gradient: 'from-blue-500 to-blue-600',
      bgGradient: 'from-blue-50 to-blue-100'
    },
    {
      icon: TrendingUp,
      title: 'التنافسية',
      description: 'زيادة المقدرة التنافسية لدى الشركة لمنافسة اكبر الشركات.',
      gradient: 'from-green-500 to-green-600',
      bgGradient: 'from-green-50 to-green-100'
    },
    {
      icon: Target,
      title: 'التوسع',
      description: 'بتغطية السوق المحلي والأسواق المجاورة باحتياجاتها من الخدمات والاضافات الحديثه والتي تساعد على تطور وتسهيل العمل لدى الشركات والمؤسسات الحكوميه والخاصه...',
      gradient: 'from-purple-500 to-purple-600',
      bgGradient: 'from-purple-50 to-purple-100'
    },
    {
      icon: RefreshCw,
      title: 'الاستمرارية',
      description: 'وذلك بالمحافظة والاستمرار على جلب افضل التقنيات والحلول المساعده للشركات والمؤسسات وكذلك بتدريب وتأهيل الموظفين.',
      gradient: 'from-orange-500 to-orange-600',
      bgGradient: 'from-orange-50 to-orange-100'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-white via-gray-50 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/4 left-0 w-72 h-72 bg-green-200 rounded-full filter blur-3xl opacity-20"></div>
      <div className="absolute bottom-1/4 right-0 w-72 h-72 bg-blue-200 rounded-full filter blur-3xl opacity-20"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20" dir="rtl">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-semibold">مميزاتنا</span>
          </div>
          <h2 className="text-5xl font-extrabold text-gray-900 mb-4">
            لماذا <span className="bg-gradient-to-r from-green-600 to-green-500 bg-clip-text text-transparent">نحن مميزون</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            نقدم خدمات متميزة بأعلى معايير الجودة والاحترافية
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="group relative bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 text-right border border-gray-100 transform hover:-translate-y-2"
                dir="rtl"
              >
                {/* Background gradient on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${feature.bgGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-3xl`}></div>
                
                <div className="relative z-10">
                  <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${feature.gradient} rounded-2xl mb-6 shadow-lg transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-gray-800 transition-colors">{feature.title}</h3>
                  <p className="text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors">{feature.description}</p>
                </div>
                
                {/* Decorative corner */}
                <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${feature.gradient} opacity-10 rounded-bl-full`}></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;